import { z } from '../zod';
import { OrderBumpParamsValidationSchema } from './params';

export const DeleteOrderBumpInputValidationSchema = OrderBumpParamsValidationSchema;

export type DeleteOrderBumpInput = z.infer<typeof DeleteOrderBumpInputValidationSchema>;

export const DeleteOrderBumpResponseValidationSchema = z
  .object({
    data: z.object({
      success: z.boolean(),
      message: z.string(),
    }),
  })
  .meta({
    description: 'Confirms the order bump was removed from the page. The product itself is kept.',
  });
